export default "__VITE_ASSET__B102d5_D__"